import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UUID } from 'angular2-uuid';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'ngx-loading';
import { Crop } from '../../shared/classes/cropModel';
import { AuthenticateService } from '../../shared/services/authenticate.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CropsService } from 'src/app/shared/services/crops.service';
import { CognitoService } from 'src/app/shared/services/cognito.service';
import { FileUploadService } from 'src/app/shared/services/fileupload.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
@Component({
  selector: 'app-crop',
  templateUrl: './crop.component.html',
  styleUrls: ['./crop.component.sass']
})
export class CropComponent implements OnInit {

  @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  heading = 'Crops';
  subheading = 'fill all the details as per instructions';
  icon = 'pe-7s-wallet icon-gradient bg-plum-plate';
  currentJustify2 = 'justified';
  public loading: boolean;
  showList: boolean = true;
  type: string = 'save'
  editIndex: number;
  cropDataArray = [];
  cobj: { maincropId: string; group: string; cropName: string; ScientificName: string; cropCategory: string; mainCropImage: any, cropImages: any };
  imageNameList = [];
  cropForm: FormGroup;
  submitted = false;
  urls = [];
  imageUploadService: string;
  globalImgUrl: string;
  crop: Crop;
  groupName: string;
  btnLoading: boolean = false;
  uploadFileList: any[] = [];
  previousPage: number;
  skip: number;
  collectionSize: number;
  page = 1;
  searchStr: string = '';
  showsearchdata: boolean = true;
  categoryArray: any = [];
  mainCropImage: any;
  maincropUrl: string = '';
  maincropId: string = '';
  mainImageUploadService: string;
  languageList: any = [];
  regLanguage: string = '';
  name: string = '';
  langObj: any = {};
  langaugeArray: any = [];
  editLngRow: any[] = [];
  editLngObj: any = {};
  selectedFiles: FileList;

  constructor(private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private profileService: ProfileService,
    private authService: AuthenticateService,
    private cropsService: CropsService,
    private fileUploadService: FileUploadService,
    private cognitoService: CognitoService) { }
  ngOnInit() {
    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
    }
    this.cognitoService.getCurrentUserToken().then((res: any) => {
      this.groupName = res.attributes.family_name;
      this.getAllCrop();
      this.getAllCategories();
    })
    this.languageList = [
      { languageName: 'বাংলা', shortName: 'BN' },
      { languageName: 'ગુજરાતી', shortName: 'GU' },
      { languageName: 'हिन्दी', shortName: 'HI' },
      { languageName: 'ಕನ್ನಡ', shortName: 'KN' },
      { languageName: 'मराठी', shortName: 'MR' },
      { languageName: 'മലയാളം', shortName: 'ML' },
      { languageName: 'ଓଡ଼ିଆ', shortName: 'OR' },
      { languageName: 'ਪੰਜਾਬੀ', shortName: 'PA' },
      { languageName: 'தமிழ்', shortName: 'TA' },
      { languageName: 'తెలుగు', shortName: 'TE' },
      { languageName: 'اُردُو', shortName: 'UR' },
    ];
    this.cropForm = this.formBuilder.group({
      cropName: ['', Validators.required],
      cropCategory: ['', Validators.required],
      ScientificName: ['', Validators.required],
      cropDescription: [' ', Validators.required]
    });
  }

  getAllCategories() {
    this.categoryArray = [];
    let obj = {
      group: this.groupName
    }
    // this.cropsService.getCategoriesList(obj).then((data: any) => {
    this.cropsService.getCategories(obj).then((data: any) => {
      console.log("crop categories == ", data);
      if (data.length > 0) {
        data.sort(function (a, b) {
          return a.categoryName.localeCompare(b.categoryName);
        });
        this.categoryArray = data;
        // for (let i = 0; i < data.length; i++) {
        //   this.categoryArray.push(data[i].categoryName);
        //   console.log("categoryArray ", this.categoryArray);
        // }
      }
    })
  }

  loadPage(pageNumber: number) {
    this.loading = true;
    console.log("page number ", pageNumber, this.previousPage)
    if (pageNumber !== this.previousPage) {
      this.skip = (pageNumber * 20) - 20;
      this.previousPage = pageNumber;
      this.loadData(this.skip);
    }
  }

  loadData(skip) {
    this.loading = true;
    this.cropDataArray = [];
    var options = {
      group: this.groupName,
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: skip
      // }
    }
    this.cropsService.getCropData(options).then((data: any) => {
      console.log("getDemandCount : ", data);
      if (data.length > 0) {
        this.cropDataArray = data;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
    var count = { group: this.groupName }
    this.cropsService.getCropscount(count).then((data: any) => {
      console.log("Demand size : ", data)
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  getAllCrop() {
    this.loading = true;
    this.showsearchdata = true;
    this.cropDataArray = [];
    var options = {
      group: this.groupName,
      // options: {
      limit: 20,
      // sortFields: { createTs: -1 },
      skip: 0
      // }
    }
    console.log("cropData options == ", options);
    this.cropsService.getCropData(options).then((data: any) => {
      console.log("cropData == ", data);
      if (data.length > 0) {
        this.cropDataArray = data;
        console.log("varietyarray", this.cropDataArray)
        this.loading = false;
      } else {
        this.loading = false;
      }
    })
    var count = { group: this.groupName }
    console.log("COUNT obj: ", count);
    this.cropsService.getCropscount(count).then((data: any) => {
      console.log("COUNT : ", data);
      if (data.length > 0) {
        this.collectionSize = data[0].size;
      }
    });
  }

  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }

  addForms() {
    this.btnLoading = false;
    this.cropForm.reset();
    this.showList = false;
    this.langaugeArray = [];
    this.maincropUrl = '';
    // this.cobj = { maincropId: '', group: '', cropName: '', ScientificName: '', cropCategory: '', cropImages: [] };
    this.cobj = { maincropId: '', group: '', cropName: '', ScientificName: '', cropCategory: '', mainCropImage: [], cropImages: [] };
    console.log("cobj ", this.cobj);
    this.type = 'save';
  }

  back() {
    this.showList = true;
    this.type = 'save';
    this.cropForm.reset();
    this.imageNameList = [];
    this.langaugeArray = [];
    this.urls = [];
    this.maincropId = '';
    this.maincropUrl = '';
    this.getAllCrop();
  }

  imageInput(event) {
    if (event.target.files && event.target.files[0]) {
      var fileLength = event.target.files.length
      for (let i = 0; i < fileLength; i++) {
        if (event.target.files[i].type.split('/')[0] == 'image') {
          var reader = new FileReader()
          reader.onload = (event: any) => {
            this.urls.push(event.target.result);
          }
          reader.readAsDataURL(event.target.files[i]);
          let iuuid = UUID.UUID();
          this.imageUploadService = 'var_' + iuuid + "." + event.target.files.item(0).type.split('/')[1];
          this.imageNameList.push(this.imageUploadService);
          const formData: FormData = new FormData();
          formData.set('file', event.target.files[i], this.imageUploadService);
          formData.append('name', this.imageUploadService);
          this.uploadFileList.push(formData)
        }
      }
    }
  }

  mainImageInput(event) {
    this.selectedFiles = event.target.files;
    console.log("event : ", event);
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => { // called once readAsDataURL is completed
        this.maincropUrl = event.target.result;
      }
      let iuuid = UUID.UUID();
      this.maincropId = this.maincropId ? this.maincropId : iuuid;
      this.mainImageUploadService = this.maincropId + "." + event.target.files.item(0).type.split('/')[1];
      this.mainCropImage = event.target.files[0]
      console.log("mainCropImage", this.mainCropImage)
    }
  }
  deleteImage(index) {
    this.imageNameList.splice(index, 1);
    this.urls.splice(index, 1);
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.splice(index, 1);
    }
    console.log("deleteImage ", this.imageNameList, event);
  }

  // mainUploadFileToActivity() {
  //   console.log("dd ", this.mainImageUploadService, this.mainCropImage)
  //   if (this.mainCropImage != '') {
  //     this.registerService.postFile(this.mainCropImage, this.mainImageUploadService).then(data => {
  //     }, error => {
  //       console.log(error);
  //     });
  //   }
  // }
  mainUploadFileToActivity() {
    console.log("dd ", this.mainImageUploadService, this.mainCropImage)
    if (this.mainCropImage != '') {
      this.fileUploadService.uploadFile(this.mainCropImage, this.mainImageUploadService);
    }
  }
  closeModel() {
    this.regLanguage = '';
    this.name = '';
    this.langaugeArray = [];
  }

  openLanguageModel(content) {
    this.regLanguage = '';
    this.name = '';
    if (this.cobj['cropNameLang'] && this.langaugeArray.length == 0) {
      for (const [key, value] of Object.entries(this.cobj['cropNameLang'])) {
        let obj = {
          language: `${key}`,
          value: `${value}`
        }
        this.langaugeArray.push(obj);
      }
      console.log("langaugeArray", this.langaugeArray);
    }
    let config: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'lg'
    };
    this.modalService.open(content, config);
  }

  uploadFileToActivity() {
    for (var i = 0; i < this.uploadFileList.length; i++) {
      this.fileUploadService.uploadMultipleFiles(this.uploadFileList[i], this.imageUploadService);
    }
  }

  handleInput(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  addData() {
    let language = this.languageList.filter(item => item.languageName == this.regLanguage)[0].shortName;
    let obj = {
      language: language,
      value: this.name
    }
    this.langaugeArray.push(obj);
    this.regLanguage = '';
    this.name = '';
    console.log("langaugeArray", JSON.stringify(this.langaugeArray));
  }

  updateLngRow(updateIndex) {
    this.langaugeArray[updateIndex].language = this.languageList.filter(item => item.languageName == this.editLngObj.language)[0].shortName;
    this.langaugeArray[updateIndex].value = this.editLngObj.value;
    console.log("langaugeArray", this.langaugeArray);
    this.editLngRow = [];
    this.editLngObj = {};
    this.editLngRow[updateIndex] = false;
  }
  cancelLngRow(cancelIndex) {
    this.editLngRow = [];
    this.editLngObj = {};
    this.editLngRow[cancelIndex] = false;
  }
  deleteLngRow(index) {
    this.langaugeArray.splice(index, 1);
  }
  editLngRowData(editIndex) {
    this.editLngRow = [];
    this.editLngObj = {};
    this.editLngRow[editIndex] = true;
    this.editLngObj = this.langaugeArray[editIndex];
    this.editLngObj.language = this.languageList.filter(item => item.shortName == this.langaugeArray[editIndex].language)[0].languageName;
    console.log("editLngObj", this.editLngObj)
  }

  onChangeCategory(categoryid) {
    console.log("catagory : ", categoryid);
    let catagory = this.categoryArray.filter(item => item.categoryId == categoryid);
    console.log("catagory", catagory);
    this.cobj.cropCategory = catagory[0].categoryName;
  }

  addLanguageData() {
    let obj = {};
    for (let i = 0; i < this.langaugeArray.length; i++) {
      obj[this.langaugeArray[i].language] = this.langaugeArray[i].value
    }
    this.langObj = obj;
    console.log("obj", obj);
  }

  saveData() {
    this.loading = true;
    this.btnLoading = true;
    // this.uploadFileToActivity();
    let uuid = this.maincropId;
    this.cobj.maincropId = uuid;
    this.cobj.cropImages = this.imageNameList;
    this.cobj.mainCropImage = this.mainImageUploadService;
    this.cobj.group = this.groupName;
    let temp = { 'EN': this.cobj.cropName }
    Object.assign(this.langObj, temp);
    this.cobj['cropNameLang'] = this.langObj;
    this.crop = this.cobj;
    console.log("saveData result : ", JSON.stringify(this.cobj));
    this.cropsService.createCrop(this.cobj).then((data: any) => {
      console.log("saveData result : ", JSON.stringify(data));
      if (this.mainCropImage != undefined) {
        this.mainUploadFileToActivity();
      }
      if (this.imageUploadService) {
        this.uploadFileToActivity();
      }
      this.btnLoading = false;
      if (data) {
        this.cropForm.reset();
        this.imageNameList = [];
        this.langaugeArray = [];
        this.urls = [];
        this.maincropId = '';
        this.maincropUrl = '';
        this.showList = true;
        this.uploadFileList = [];
        this.getAllCrop();
      } else {
        this.loading = false;
        this.btnLoading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
      }
    })
  }

  editData(index) {
    this.langaugeArray = [];
    this.uploadFileList = [];
    this.maincropId = '';
    this.showList = false;
    this.imageNameList = [];
    this.urls = [];
    this.editIndex = index;
    console.log("cropdata edited", this.cropDataArray[index]);
    this.cobj = this.cropDataArray[index];
    this.maincropId = this.cropDataArray[index].maincropId;
    this.maincropUrl = this.globalImgUrl + this.cobj.mainCropImage;
    this.imageNameList = this.cropDataArray[index].cropImages;
    if (this.cropDataArray[index].cropNameLang) {
      for (const [key, value] of Object.entries(this.cropDataArray[index].cropNameLang)) {
        let obj = {
          language: `${key}`,
          value: `${value}`
        }
        if (obj['language'] != 'EN') {
          this.langaugeArray.push(obj);
        }
      }
      console.log("langaugeArray", this.langaugeArray);
    }
    for (var i = 0; i < this.cropDataArray[index].cropImages.length; i++) {
      console.log("images : ", this.cropDataArray[index].cropImages[i])
      this.urls.push(this.globalImgUrl + this.cropDataArray[index].cropImages[i]);
      this.uploadFileList.push(this.globalImgUrl + this.cropDataArray[index].cropImages[i]);
    }
    this.type = 'update';
  }

  updateData() {
    this.loading = true;
    this.btnLoading = true;
    this.langObj = {};
    for (let i = 0; i < this.langaugeArray.length; i++) {
      this.langObj[this.langaugeArray[i].language] = this.langaugeArray[i].value
    }
    let temp = { 'EN': this.cobj.cropName };
    let croplang = Object.assign(this.langObj, temp);
    this.cobj['cropNameLang'] = croplang;
    this.cobj['mainCropImage'] = this.mainImageUploadService != undefined ? this.mainImageUploadService : this.cobj.mainCropImage;
    this.cobj.cropImages = this.cobj.cropImages.concat(this.imageNameList.filter((item) => {
      return this.cobj.cropImages.indexOf(item) < 0;
    }));
    let uobj = {
      cropName: this.cobj.cropName,
      cropNameLang: this.cobj['cropNameLang'],
      mainCropImage: this.cobj.mainCropImage,
      cropImages: this.cobj.cropImages,
    }
    let profileObj = {
      group: this.groupName,
      maincropId: this.cropDataArray[this.editIndex].maincropId,
    }
    console.log("cobj : ", JSON.stringify(this.cobj));
    delete this.cobj['_id']
    this.cropsService.updateCrop(this.cobj).then((data: any) => {
      console.log("Profile data last : ", data);
      this.profileService.getProfileDefData(profileObj).then((profileData: any) => {
        console.log('profileDef data', profileData);
        if (profileData.length > 0) {
          for (let i = 0; i < profileData.length; i++) {
            this.updateProfileDef(uobj, profileData[i]);
          }
        }
      })
      if (this.mainCropImage != undefined) {
        this.mainUploadFileToActivity();
      }
      if (this.imageUploadService) {
        this.uploadFileToActivity();
      }
      this.btnLoading = false;
      if (data) {
        Swal({ title: "Updated successfully" })
        this.cropForm.reset();
        this.imageNameList = [];
        this.langaugeArray = [];
        this.urls = [];
        this.uploadFileList = [];
        this.maincropId = '';
        this.maincropUrl = '';
        this.showList = true;
        this.getAllCrop();
      } else {
        this.btnLoading = false;
        this.loading = false;
        Swal.fire(
          'Error',
          'Data not Submitted (please contact admin)',
          'error'
        )
      }
    })
  }

  updateProfileDef(pobj, selectedCrop) {
    this.profileService.updateProfileDef(pobj, selectedCrop).then((data: any) => {
      console.log("upadate prof", data)
    })
  }

  searchByName() {
    if (this.searchStr != '') {
      this.loading = true;
      var obj = {
        group: this.groupName,
        field: 'cropName',
        text: this.searchStr,
        tableName: 'cropdata',
      };
      console.log("search obj : ", obj)
      this.cropsService.getCropRegex(obj).then((data: any) => {
        console.log("searched", data)
        this.searchStr = '';
        this.cropDataArray = [];
        if (data.length > 0) {
          this.cropDataArray = data;
          this.showsearchdata = false;
          this.loading = false;
          console.log("cropDataArray", this.cropDataArray);
        }
        else {
          this.loading = false;
          this.showsearchdata = false;
        }
      })
    }
  }

  deleteData(index) {
    this.cropDataArray.splice(index, 1)
  }
}